import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import PublicNavbar from "./PuplicNavbar";
import PublicFooter from "./PublicFooter";
import WhatsAppButton from "../../components/WhatsAppButton";

const PublicLayout = () => {
  const location = useLocation();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background:
          "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        position: "relative",
        overflow: "hidden",
        overflowX: "hidden", // منع التمرير الأفقي
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          background:
            "radial-gradient(circle at 20% 50%, rgba(102, 126, 234, 0.1) 0%, transparent 50%), " +
            "radial-gradient(circle at 80% 80%, rgba(118, 75, 162, 0.1) 0%, transparent 50%)",
          pointerEvents: "none",
          zIndex: 0,
        },
      }}
    >
      {/* Navbar ثابت فوق */}
      <PublicNavbar />

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: { xs: 8, sm: 9, md: 10 },
          pb: { xs: 2, sm: 3, md: 4 },
          px: { xs: 1, sm: 2 }, // padding أفقي للموبايل
          position: "relative",
          zIndex: 1,
          minHeight: "calc(100vh - 200px)",
          width: "100%",
          maxWidth: "100vw", // منع تجاوز عرض الشاشة
        }}
      >
        <Box
          key={location.pathname}
          sx={{
            animation: "fadeIn 0.4s ease-in-out",
            "@keyframes fadeIn": {
              from: {
                opacity: 0,
                transform: "translateY(20px)",
              },
              to: {
                opacity: 1,
                transform: "translateY(0)",
              },
            },
          }}
        >
          <Outlet />
        </Box>
      </Box>

      {/* Footer */}
      <PublicFooter />

      {/* WhatsApp Floating Button */}
      <WhatsAppButton />
    </Box>
  );
};

export default PublicLayout;
